import { isPresent } from "@/lib/utils"

export const filenameToSprite = filename => filename.split(".")[0]

export const toSprite = audio =>
  isPresent(audio)
    ? {
        sprite: filenameToSprite(audio.filename),
        duration: audio.length
      }
    : {}
